import { AppState } from '../../../redux/initialStates/AppState';
import { IPromoCodes } from '../../../companyLocations/redux/initialStates/promoCodes';

export const selectLocationPromoCode = (state: AppState): IPromoCodes => state.locationPromoCodes;
